import { render, staticRenderFns } from "./purchaseReport.vue?vue&type=template&id=37c156c6&scoped=true"
import script from "./purchaseReport.vue?vue&type=script&lang=js"
export * from "./purchaseReport.vue?vue&type=script&lang=js"
import style0 from "./purchaseReport.vue?vue&type=style&index=0&id=37c156c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c156c6",
  null
  
)

export default component.exports